import { required, helpers } from 'vuelidate/lib/validators'
const phoneformat = helpers.regex('phoneformat', /^([+])?(([-() ])*(\d+)*)*$/)

export default [{
  "id": "first-name",
  "type": "input",
  "label": "名字",
  "size": 50,
  "model": "firstName",
  "validation": {
    required
  },
  "errorMsg": [
    "請輸入您的名字。"
  ]
},
{
  "id": "last-name",
  "type": "input",
  "label": "姓氏",
  "size": 50,
  "model": "lastName",
  "validation": {
    required
  },
  "errorMsg": [
    "請輸入您的姓氏。"
  ]
},
{
  "id": "mobile1",
  "type": "input",
  "label": "移動電話",
  "size": 50,
  "model": "mobile1",
  "validation": {
    required,
    phoneformat
  },
  "errorMsg": [
    "請輸入您的電話號碼。",
    "請輸入有效的電話號碼。"
  ]
},
{
  "id": "mobile2",
  "type": "input",
  "label": "次選電話號碼",
  "size": 50,
  "model": "mobile2",
  "validation": {
    phoneformat
  },
  "errorMsg": [
    "請輸入有效的電話號碼。"
  ]
},
{
  "id": "address1",
  "type": "input",
  "label": "地址行1",
  "size": 100,
  "model": "address1",
  "validation": {
    required
  },
  "errorMsg": [
    "請輸入您的地址。"
  ]
},
{
  "id": "address2",
  "type": "input",
  "label": "地址行 2",
  "size": 100,
  "model": "address2"
},
{
  "id": "postal-code",
  "type": "input",
  "label": "郵政編碼",
  "size": 50,
  "model": "postalCode",
  "validation": {
    required
  },
  "errorMsg": [
    "請輸入您的郵政編碼。"
  ]
},
{
  "id": "country",
  "type": "text",
  "label": "國家/地區",
  "size": 50,
  "model": "countryName"
}
]